// extracted by mini-css-extract-plugin
export default {"FormContainer":"PFwkcN8dnChUHI8X1IPu","StatusIcon":"Qds3LjMTzDLCqESVYjXB"};